@if (!!paymentMethods?.length || client.isCms) {
    <span class="p2 col-1 va-m inline-block">{{ 'Pay with' | translate }}</span>
}

<!-- payment icons -->
@for (method of paymentMethods; track method) {
  <payment-icon
    [method]="method.payment_method_icon"
    [style.fontSize.px]="24"
  class="m-l-2 va-m inline-block"></payment-icon>
}
